import { render, staticRenderFns } from "./printPayFeeXiangyun.vue?vue&type=template&id=063fecd6&scoped=true"
import script from "./printPayFeeXiangyun.vue?vue&type=script&lang=js"
export * from "./printPayFeeXiangyun.vue?vue&type=script&lang=js"
import style0 from "./printPayFeeXiangyun.vue?vue&type=style&index=0&id=063fecd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fecd6",
  null
  
)

export default component.exports